import React, { memo } from 'react';
import FooterNavItem from './FooterNavItem.molecule';
import { LinkProps } from '../../../interfaces/LinkProps.interface';

interface FooterNavItemsProps {
  items: LinkProps[];
}

const FooterNavItems: React.FC<FooterNavItemsProps> = ({ items }) => {
  return (
    <ul className="space-y-5">
      {items.map((item) => (
        <FooterNavItem key={item._uid} {...item} />
      ))}
    </ul>
  );
};

FooterNavItems.defaultProps = {
  items: [],
};

export default memo(FooterNavItems);
